module.exports = __webpack_public_path__ + "img/egoposities.7544a14b.png";